import SingleClientReportForm from './SingleClientReportForm';

export default SingleClientReportForm;


// WEBPACK FOOTER //
// ./src/features/reports/components/single-client/form/index.js